import { useMutation } from '@tanstack/react-query';
import { Program } from '@shared/types/programs';
import { API } from '@src/api/index.ts';
import { queryClient } from '@src/api/query-client.ts';
import { EntityByIdParam } from '@src/api/types.ts';

export const useLikeProgramMutation = () => {
  return useMutation({
    mutationFn: async (params: EntityByIdParam) => await API.programs.like(params),
    onSuccess: (_response, { id }) => {
      queryClient.setQueriesData({ queryKey: ['program', id] }, (oldData: Program) => {
        if (!oldData) return oldData;
        return {
          ...oldData,
          liked: true,
          likes: oldData.likes + 1,
        };
      });

      queryClient.invalidateQueries({ queryKey: ['program', id] });
    },
  });
};
